import React, { useState } from 'react';
import Button, { ButtonWithLoadingState } from './Button';
import Buttons from './Buttons';
import * as styles from './ConfirmationModal.module.scss';
import { ModalActionFooter, ModalTitle } from './Modal';

interface ConfirmationModalProps {
  cancelButtonText?: string;
  confirmButtonText?: string;
  close: () => void;
  message?: React.ReactNode;
  onConfirm: () => Promise<unknown>;
  title: string;
  width?: number;
}

const ConfirmationModal = ({
  close,
  cancelButtonText = 'Cancel',
  confirmButtonText = 'Confirm',
  message,
  onConfirm,
  title,
  width = 375,
}: ConfirmationModalProps) => {
  const [isConfirming, setIsConfirming] = useState(false);
  const handleConfirm = () => {
    setIsConfirming(true);
    onConfirm()
      .then(close)
      .finally(() => {
        setIsConfirming(false);
      });
  };
  return (
    <div className={styles.modal} style={{ maxWidth: width }}>
      <ModalTitle noMargin small>
        {title}
      </ModalTitle>
      <div className={styles.message}>{message}</div>
      <ModalActionFooter
        primary={
          <Buttons>
            <Button onClick={close} variant="secondary">
              {cancelButtonText}
            </Button>
            <ButtonWithLoadingState
              loading={isConfirming}
              onClick={handleConfirm}
              variant="primary"
            >
              {confirmButtonText}
            </ButtonWithLoadingState>
          </Buttons>
        }
      />
    </div>
  );
};

export default ConfirmationModal;
